
export default class EmptyObjectError extends Error {
    constructor(message: string) {
        super(message)
        this.name = "EmptyObjectError"
    }
}